<template>
    <div>
        <b-form-group
            label="Pattern"
            label-for="pattern"
            :label-cols="3"
            :horizontal="false">
            <b-form-input type="text" v-model="constraints.date.pattern" value="YYYYY-MM-DD"></b-form-input>
        </b-form-group>
        <b-form-group
            description="Disable all dates before current day"
            label="Disable past dates"
            label-for="disable_past_dates"
            :label-cols="3"
            :horizontal="false">
             <c-switch class="mx-1" color="success" variant="pill" v-model="constraints.date.disable_past_dates"/>
        </b-form-group>
        <b-form-group
            description="Disable all dates after current day"
            label="Disable future dates"
            label-for="disable_future_dates"
            :label-cols="3"
            :horizontal="false">
             <c-switch class="mx-1" color="success" variant="pill" v-model="constraints.date.disable_future_dates"/>
        </b-form-group>

        <b-form-group
            label="Disabled dates"
            label-for="disabled_dates"
            :label-cols="3"
            :horizontal="true">
            <div class="form-actions" style="margin: 10px">
                <b-button variant="success" @click="disabledDatesModal.show = true">Setup</b-button>
            </div>
            <main-dialog size="lg" title="Disabled dates" v-model="disabledDatesModal.show" @ok="saveDisabledDates()">
                <b-form-group
                    label="From"
                    label-for="from"
                    :label-cols="3"
                    :horizontal="false">
                    <b-form-input type="date" v-model="constraints.date.disabled_dates.from"></b-form-input>
                </b-form-group>
                <b-form-group
                    label="To"
                    label-for="to"
                    :label-cols="3"
                    :horizontal="false">
                    <b-form-input type="date" v-model="constraints.date.disabled_dates.to"></b-form-input>
                </b-form-group>
                <b-form-group
                    description="Use CTRL to select multiple values"
                    label="Days"
                    label-for="days"
                    :label-cols="3"
                    :horizontal="false">
                   <b-form-select id="days"
                    :plain="true"
                    :multiple="true"
                    :options="days"
                    v-model="constraints.date.disabled_dates.days"
                    >
                    </b-form-select>
                </b-form-group>
                <b-form-group
                    description="Use CTRL to select multiple values"
                    label="Days of month"
                    label-for="daysOfMonth"
                    :label-cols="3"
                    :horizontal="false">
                    <b-form-select id="days"
                    :plain="true"
                    :multiple="true"
                    :options="daysOfMonth"
                    v-model="constraints.date.disabled_dates.days_of_month"
                    >
                    </b-form-select>
                </b-form-group>
                <b-form-group
                    label="Dates"
                    label-for="dates"
                    description="To remove dates click on pills"
                    :label-cols="3"
                    :horizontal="false">
                    <div style="height: 50px; overflow: auto; margin-right: 10px" class="pickedDates form-control"><b-badge variant="secondary" @click="removeDisabledDate(date)" v-for="date in constraints.date.disabled_dates.dates" :key="date">{{ date }}</b-badge></div>
                    <b-form-input type="date" @change="dateDisablePicked"></b-form-input>
                </b-form-group>

                <b-form-group
                    label="Range"
                    label-for="range"
                    :label-cols="3"
                    :horizontal="false">
                    <div style="height: 50px; overflow: auto; margin-right: 10px" class="pickedDates form-control"><b-badge variant="secondary" @click="removeDisabledDateInRange(date)" v-for="date in constraints.date.disabled_dates.ranges" :key="date.to + date.from">{{ date.from }} <> {{ date.to }}</b-badge></div>
                    <b-form-group
                    label="From"
                    label-for="from"
                    :label-cols="3"
                    :horizontal="false">
                    <b-form-input type="date" v-model="dateRangeFrom"></b-form-input>
                    </b-form-group>
                    <b-form-group
                    label="To"
                    label-for="to"
                    :label-cols="3"
                    :horizontal="false">
                    <b-form-input type="date" @change="rangeDisablePicked"></b-form-input>
                    </b-form-group>
                </b-form-group>
            </main-dialog>
        </b-form-group>
        <b-form-group
            label="Highlighted dates"
            label-for="highlighted_dates"
            :label-cols="3"
            :horizontal="true">
            <div class="form-actions" style="margin: 10px">
                <b-button variant="success" @click="highlightedDatesModal.show = true">Setup</b-button>
            </div>
            <main-dialog size="lg" title="Highlighted dates" v-model="highlightedDatesModal.show" @ok="saveDisabledDates">
                <b-form-group
                    label="From"
                    label-for="from"
                    :label-cols="3"
                    :horizontal="false">
                    <b-form-input type="date" v-model="constraints.date.highlighted_dates.from"></b-form-input>
                </b-form-group>
                <b-form-group
                    label="To"
                    label-for="to"
                    :label-cols="3"
                    :horizontal="false">
                    <b-form-input type="date" v-model="constraints.date.highlighted_dates.to"></b-form-input>
                </b-form-group>
                <b-form-group
                    description="Use CTRL to select multiple values"
                    label="Days"
                    label-for="days"
                    :label-cols="3"
                    :horizontal="false">
                   <b-form-select id="days"
                    :plain="true"
                    :multiple="true"
                    :options="days"
                    v-model="constraints.date.highlighted_dates.days"
                    >
                    </b-form-select>
                </b-form-group>
                <b-form-group
                    description="Use CTRL to select multiple values"
                    label="Days of month"
                    label-for="daysOfMonth"
                    :label-cols="3"
                    :horizontal="false">
                    <b-form-select id="days"
                    :plain="true"
                    :multiple="true"
                    :options="daysOfMonth"
                    v-model="constraints.date.highlighted_dates.days_of_month"
                    >
                    </b-form-select>
                </b-form-group>
                <b-form-group
                    label="Dates"
                    label-for="dates"
                    :label-cols="3"
                    :horizontal="false">
                    <div style="height: 50px; overflow: auto; margin-right: 10px" class="pickedDates form-control"><b-badge variant="secondary" @click="removeHighlightedDate(date)" v-for="date in constraints.date.highlighted_dates.dates" :key="date">{{ date }}</b-badge></div>
                    <b-form-input type="date" @change="dateHighlightPicked"></b-form-input>
                </b-form-group>

                <b-form-group
                    label="Range"
                    label-for="range"
                    :label-cols="3"
                    :horizontal="false">
                    <div style="height: 50px; overflow: auto; margin-right: 10px" class="pickedDates form-control"><b-badge variant="secondary" @click="removeHighlightedDate(date)" v-for="date in constraints.date.highlighted_dates.ranges" :key="date.to + date.from">{{ date.from }} - {{ date.to }}</b-badge></div>
                    <b-form-group
                    label="From"
                    label-for="from"
                    :label-cols="3"
                    :horizontal="false">
                    <b-form-input type="date" v-model="dateRangeFrom"></b-form-input>
                    </b-form-group>
                    <b-form-group
                    label="To"
                    label-for="to"
                    :label-cols="3"
                    :horizontal="false">
                    <b-form-input type="date" @change="rangeHighlightPicked"></b-form-input>
                    </b-form-group>
                </b-form-group>
                <b-form-group
                    description="Highlight disabled dates"
                    label="Highlight disabled dates"
                    label-for="to"
                    :label-cols="3"
                    :horizontal="false">
                    <c-switch class="mx-1" color="success" variant="pill" v-model="constraints.date.highlighted_dates.include_disabled"/>
                    </b-form-group>
            </main-dialog>
        </b-form-group>
    </div>
</template>
<script>
import { Switch as cSwitch } from '@coreui/vue'

export default {
    components: {
        cSwitch
    },
    props: {
        value: {
            type: Object | String
        }
    },
    data: function() {
        return {
            dateRangeFrom: "",
            dateRangeTo: "",
            disabledDatesModal: {
                show: false
            },
            highlightedDatesModal: {
                show: false
            }
        }
    },
    computed: {
        constraints() {
            let base = this.value

            base.date = {
                pattern: base.date.pattern || "YYYY-MM-DD",
                disable_past_dates: base.date.disable_past_dates || false,
                disable_future_dates: base.date.disable_future_dates || false,
                disabled_dates: {
                    dates: base.date.disabled_dates.dates || [],
                    to: base.date.disabled_dates.to || "",
                    from: base.date.disabled_dates.from || "",
                    days: base.date.disabled_dates.days || [],
                    days_of_month: base.date.disabled_dates.days_of_month || [],
                    ranges: base.date.disabled_dates.ranges || []
                },
                highlighted_dates: {
                    dates: base.date.highlighted_dates.dates || [],
                    to: base.date.highlighted_dates.to || "",
                    from: base.date.highlighted_dates.from || "",
                    days: base.date.highlighted_dates.days || [],
                    days_of_month: base.date.highlighted_dates.days_of_month || [],
                    ranges: base.date.highlighted_dates.ranges || [],
                    include_disabled: base.date.highlighted_dates.include_disabled || false
                }
            }

            return base;
        },
        days() {
            return [
                    {
                        text: 'Monday',
                        value: 1
                    },
                    {
                        text: 'Tuesday',
                        value: 2
                    },
                    {
                        text: 'Wednesday',
                        value: 3
                    },
                    {
                        text: 'Thursday',
                        value: 5
                    },
                    {
                        text: 'Friday',
                        value: 5
                    },
                    {
                        text: 'Saturday',
                        value: 6
                    },
                    {
                        text: 'Sunday',
                        value: 0
                    },
                    ]
        },
        daysOfMonth() {
            let days = []

            for (var i = 1; i <= 31; i++) {
                days.push(i)
            }

            return days
        }
    },
    methods: {
        removeDisabledDate(d) {
            let dates = this.constraints.date.disabled_dates.dates
            
            dates = dates.filter(date => {
                return date != d
            })

            this.constraints.date.disabled_dates.dates = dates
        },

        removeDisabledDateInRange(d) {
            let dates = this.constraints.date.disabled_dates.ranges
            
            dates = dates.filter(date => {
                return date != d
            })

            this.constraints.date.disabled_dates.ranges = dates
        },

        dateDisablePicked(d) {
            if (this.constraints.date.disabled_dates.dates == null) {
                this.constraints.date.disabled_dates.dates = []
            }

            if (this.constraints.date.disabled_dates.dates.indexOf(d) == -1) {
                this.constraints.date.disabled_dates.dates.push(d)

                return
            }

            return false
        },

        rangeDisablePicked(d) {
            this.dateRangeTo = d
            
            if (this.constraints.date.disabled_dates.ranges == null) {
                this.constraints.date.disabled_dates.ranges = []
            }
                
            let found = this.constraints.date.disabled_dates.ranges.find(el => {
                return el.from == this.dateRangeFrom && el.to == this.dateRangeTo;
            })

            if (!found) {
                this.constraints.date.disabled_dates.ranges.push({
                    from: this.dateRangeFrom,
                    to: this.dateRangeTo
                })

                this.dateRangeFrom = ""
                this.dateRangeTo = ""

                return
            }
        },

        removeHighlightedDate(d) {
            let dates = this.constraints.date.highlighted_dates.dates
            
            dates = dates.filter(date => {
                return date != d
            })

            this.constraints.date.highlighted_dates.dates = dates
        },

        dateHighlightPicked(d) {
            if (this.constraints.date.highlighted_dates.dates == null) {
                this.constraints.date.highlighted_dates.dates = []
            }

            if (this.constraints.date.highlighted_dates.dates.indexOf(d) == -1) {
                this.constraints.date.highlighted_dates.dates.push(d)

                return
            }

            return false
        },

        rangeHighlightPicked(d) {
            this.dateRangeTo = d
            
            if (this.constraints.date.highlighted_dates.ranges == null) {
                this.constraints.date.highlighted_dates.ranges = []
            }
                
            let found = this.constraints.date.highlighted_dates.ranges.find(el => {
                return el.from == this.dateRangeFrom && el.to == this.dateRangeTo;
            })

            if (!found) {
                this.constraints.date.highlighted_dates.ranges.push({
                    from: this.dateRangeFrom,
                    to: this.dateRangeTo
                })

                this.dateRangeFrom = ""
                this.dateRangeTo = ""

                return
            }
        },

        saveDisabledDates() {
            this.$emit('input', this.constraints)
        }
    }
    
}
</script>